import "./Projects.css"
import wordie from "../wordie.png"
import background from "../joan-gamell-ZS67i1HLllo-unsplash.jpg"
import fitness from "../anywherefitness2.png"

export default function Projects() {
    return(
        <div className="projectsContainer">
            <h1 className="projectH1">Projects</h1>
            <div className="projectDiv">
                <div className="projectText">
                    <p className="projectP">Wordie:<br></br><br></br> A Wordle clone that functions as the original does, mainly made for fun</p>
                    <a className="projectA" href="https://projects-wordie.netlify.app/" target="_blank" rel="noopener noreferrer">Link</a>
                </div>
                <div className="projectImgContainer">
                    <img className="projectImg" src={wordie} alt=""></img>
                </div>
            </div>
            <div className="projectDiv">
                <div className="projectText">
                    <p className="projectP">Anywhere fitness: <br></br><br></br> A site where users can register for various fitness classes</p>
                    <a className="projectA" href="https://anywhere-fitness-front-end-zeta.vercel.app/" target="_blank" rel="noopener noreferrer">Link</a>
                </div>
                <div className="projectImgContainer">
                    <img className="projectImg" src={fitness} alt=""></img>
                </div>
            </div>
            <div className="projectDiv">
                <div className="projectText">
                    <p className="projectP">DM helper <br></br><br></br> Under Construction:<br></br><br></br> A site for my friend who runs DnD sessions</p>
                    {/* <a className="projectA" href=""></a> */}
                </div>
                <div className="projectImgContainer">
                    <img className="projectImg" src={background} alt=""></img>
                </div>
            </div>
            <div className="projectDiv">
                <div className="projectText">
                    <p className="projectP">Workout tracker <br></br><br></br> Under Construction: <br></br><br></br> Allows users to create/edit workout plans</p>
                    {/* <a className="projectA" href=""></a> */}
                </div>
                <div className="projectImgContainer">
                    <img className="projectImg" src={background} alt=""></img>
                </div>
            </div>
        </div>
    )
}